import React from "react";

import "./WordPhotos.css";

export default function WordPhotos(props) {
  if (props.photos) {
    console.log(props.photos);
    return (
      <section className="WordPhotos">
        <div className="row">
          {props.photos.map(function (photo, index) {
            return (
              <div className="col-4" key={index}>
                  <a href={photo.src.original} target="_blank" rel="noreferrer">
                <img
                  src={photo.src.landscape}
                  alt="photos of searched word"
                  className="img-fluid"
                />
                </a>
              </div>
            );
          })}
        </div>
      </section>
    );
  } else {
    return null;
  }
}
